import {isInViewport} from "./helpers";

const callCounters = (divWithCounters) => {
  if (!divWithCounters || !isInViewport(divWithCounters) || divWithCounters.classList.contains("counters-finished")) {
    return
  }
  const counters = divWithCounters.querySelectorAll('.counter-percentage');
  if (!counters) {
    return;
  }
  divWithCounters.classList.add("counters-finished");
  counters.forEach(counter => {

    let count = 0;
    const target = +counter.getAttribute('data-target');
    const speed = +counter.getAttribute('data-speed') || (target > 70 ? 0.35 : target > 40 ? 0.15 : 0.07);
    const updateCount = () => {
      // Lower inc to slow and higher to slow
      // Check if target is reached
      if (count < target) {
        // Add inc to count and output in counter
        counter.innerText = Math.round(count + speed);
        count += speed;
        // Call function every ms
        setTimeout(updateCount, 1);
      } else {
        counter.innerText = target;
      }
    };
    updateCount();
  });
}

export const useCounters = (className) => {
  if (typeof className !== "string") {
    return;
  }
  const divsWithCounters = [].slice.call(document.querySelectorAll(className));
  if (!divsWithCounters.length) {
    return
  }
  divsWithCounters.forEach(function (element) {
    callCounters(element);
    document.addEventListener('scroll', function () {
      callCounters(element);
    }, {
      passive: true
    });
  })
}

document.addEventListener("DOMContentLoaded", () => {

  const intro2Counters = document.querySelector('.intro2__right');
  callCounters(intro2Counters);

  const stats = [].slice.call(document.querySelectorAll(" .stats"));

  document.addEventListener('scroll', function () {
    stats.forEach(statsElement => {
      if (statsElement && isInViewport(statsElement)) {
        const statisticsChildren = [].slice.call(statsElement.querySelectorAll(" .statistics"));
        statisticsChildren.forEach(function (element) {
          var width = element.dataset.width;
          if (element.classList.contains("statistics--line")) {
            const line = element.querySelector(".statistics-line-fill");
            if (line) {
              line.style.width = width + "%";
            }
          } else {
            element.style.width = width + "%";
          }
        })
      }
    })
    callCounters(intro2Counters);
    stats.forEach(statsElement => {
      callCounters(statsElement);
    });
  }, {
    passive: true
  });

});